export const ROOF_TYPES = {
  pente_lisse: { label: 'Pente, surface lisse (métal, verre, ardoise, tuile vernissée, panneaux solaires)', coef: 0.90 },
  pente_rugueuse: { label: 'Pente, surface rugueuse (tuile béton, etc.)', coef: 0.80 },
  plat_sans_gravier: { label: 'Toit plat sans gravier', coef: 0.80 },
  plat_avec_gravier: { label: 'Toit plat avec gravier', coef: 0.70 },
  vegetalise_intensif: { label: 'Toiture végétalisée intensive (ex. jardin)', coef: 0.30 },
  vegetalise_extensif: { label: 'Toiture végétalisée extensive', coef: 0.50 },
  zone_etanche: { label: 'Zone étanche (ex. asphalte)', coef: 0.80 },
  zone_non_etanche: { label: 'Zone non étanche (ex. galet)', coef: 0.50 },
  custom: { label: 'Personnalisé', coef: 0.80 },
};

/**
 * Best-effort starting point from the building's single roof (buildings.roof in DB_SPEC.md):
 * only one pan/type is captured at building level, whereas this step supports several —
 * so this is a pre-fill suggestion, not a rigid source of truth.
 */
export const roofsFromBuilding = (building) => {
  const roof = building?.roof;
  if (!roof || !roof.surface_roof) return [];
  const type = roof.is_green_roof ? 'vegetalise_extensif' : 'pente_rugueuse';
  return [{
    id: 'building-roof',
    name: roof.building_type_roof || 'Toiture principale',
    area: roof.surface_roof,
    type,
    coef: ROOF_TYPES[type].coef,
  }];
};

export const effectiveRoofArea = (roofs) => roofs.reduce((a, r) => a + r.area * r.coef, 0);

export const totalRoofArea = (roofs) => roofs.reduce((a, r) => a + r.area, 0);

export const computeCollectedMonthly = (roofs, rainfall) => {
  const area = effectiveRoofArea(roofs);
  return rainfall.map(mm => (area * mm) / 1000); // m³
};
